import { immer } from "zustand/middleware/immer";
import { create } from "zustand";
import { GetAllAssetInsightsReq } from "@/api/studio/insights/api";

/* Store Types */
interface ReportFiltersState {
  sortBy: GetAllAssetInsightsReq["sortBy"];
  orderBy: GetAllAssetInsightsReq["orderBy"];
  reportFiltersActions: {
    setSortBy: (sortBy: GetAllAssetInsightsReq["sortBy"]) => void;
    setOrderBy: (orderBy: GetAllAssetInsightsReq["orderBy"]) => void;
  };
}

/*
 * Report Filters Store
 *
 * This store is used to manage the sort filter for the report pages.
 */
export const useReportFiltersStore = create<ReportFiltersState>()(
  immer((set) => ({
    sortBy: "desc",
    orderBy: "creative",

    /* Actions */
    reportFiltersActions: {
      setSortBy: (sortBy) =>
        set((state) => {
          state.sortBy = sortBy;
        }),
      setOrderBy: (orderBy) =>
        set((state) => {
          state.orderBy = orderBy;
        }),
    },
  })),
);
